exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-container {\n  display: block;\n  width: 100%;\n  height: 100%; }\n\n.my-container-bg {\n  background-color: #2980b9; }\n\n.my-card {\n  height: calc(100vh - 2 * 2.5rem); }\n\n.well-login-box {\n  margin: 0 auto;\n  margin-top: 5%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/pages/login/login.component.scss
// module id = ../../../../../src/app/pages/login/login.component.scss
// module chunks = main